import React, { useEffect, useState } from "react";
import "../register/Register.css";
import reg from "../../../register.png";
import Header from "../../app/layout/Header";
import icon from "../../../img_zeus/header/ICONO-ZEUS.png";
import logo from "../../../img_zeus/login/LOGO-CRHONOS-REGISTRO.png";

import { SecurityContext } from "../../../contexts/security/SecurityContext";

import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";

const Register = ({ match }) => {
  let { params, url, path } = match;
  let { token } = params;
  let [securityState, securityActions] = React.useContext(SecurityContext);
  let [state, setState] = React.useState({
    first_name: "",
    last_name: "",
    email: "",
    password: "",
    repeat_password: "",
  });
  const [inputPassword, setinputPassword] = useState(true);
  const [inputRepeatPassword, setinputRepeatPassword] = useState(true);

  let setField = (field) => (e) => {
    setState({ ...state, [field]: e.target.value });
  };

  useEffect(() => {
    if (token) {
    }
  }, [token]);
  const userRegister = (e) => {
    e.preventDefault();
  if(!securityState.loadingRegister){
    
    securityActions.register(
      state.first_name,
      state.last_name,
      state.email,
      state.password,
      state.repeat_password,
      token
    );
  }

  };

  return (
    <div className="background-register">
      <div className="w-100" className="flex header-login">
        <div className="flex">
          <div className="flex margin-auto">
            <img src={icon} className="img-header-icon-login" />
            <h2 className="tipo-title title-header">Plataforma Zeus</h2>
          </div>
        </div>
      </div>
      <div className="content-general-register">
        <img className="logo-crhonos-register" src={logo} />
        <form onSubmit={userRegister} className="form-auth form-register">
          <div className="conten-form-login">
            <h2 className="h1-register tipo-title">
              BIENVENIDO A LA PLATAFORMA
            </h2>
            <em>{securityState.formErrors.general}</em>
            <input
              className="inpt-login  tipo-description"
              onChange={setField("first_name")}
              value={state.first_name}
              type="text"
              placeholder="nombre"
            ></input>
            <input
              className="inpt-login  tipo-description"
              onChange={setField("last_name")}
              value={state.last_name}
              type="text"
              placeholder="apellido"
            ></input>
            <input
              className="inpt-login  tipo-description"
              onChange={setField("email")}
              value={state.email}
              type="email"
              placeholder="correo electrónico"
            ></input>
            <div className="inpt-login flex bg-white">
              <input
                className="input-password-register  tipo-description flex-1"
                onChange={setField("password")}
                value={state.password}
                type={inputPassword ? "password" : "text"}
                placeholder="crea una contraseña"
              ></input>
              <FontAwesomeIcon
                onClick={() => setinputPassword(!inputPassword)}
                className="cursor-action eye-register margin-auto"
                icon={faEye}
              />
            </div>
            <div className="inpt-login flex bg-white">
              <input
                className=" input-password-register tipo-description flex-1"
                onChange={setField("repeat_password")}
                value={state.repeat_password}
                type={inputRepeatPassword ? "password" : "text"}
                placeholder="confirma tu contraseña"
              ></input>
              <FontAwesomeIcon
                onClick={() => setinputRepeatPassword(!inputRepeatPassword)}
                className="cursor-action eye-register margin-auto"
                icon={faEye}
              />
            </div>

            <div className="btn-group-login">
              <Link to="/login">
                <input
                  className="btn-login btn-register btn-top-register cursor-action tipo-boton"
                  value="REGRESAR"
                  type="button"
                ></input>
              </Link>

              <input
                className="btn-login btn-top-register btn-up cursor-action tipo-boton"
                value={`${
                  !securityState.loadingRegister ? "REGISTRAR" : "CREANDO..."
                }`}
                type="submit"
              ></input>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Register;
